module.exports = __webpack_public_path__ + "assets/img/8-1.a0c177bf.png";